<div [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" class="sidenav-content" @routeAnimation>

	<ng-template #loading>
		<copo-loading-spinner *ngIf="!isError"></copo-loading-spinner>
	</ng-template>

	<ng-container *ngIf="!isLoading && !isError && productFieldsObs else loading">
		<!-- title -->
		<div class="card-title-block">
			<copo-back-button></copo-back-button>
			<div *ngIf="userPartReference" class="card-title-label">{{userPartReference}}</div>
			<div class="card-title-label">{{subcategory}}&nbsp;&&nbsp;{{form}}</div>
			<button type="button" mat-flat-button color="primary" class="product-new-specification" (click)="duplicationAction()" *ngIf=" isfeasibility && isWizard && ((user.hasService('EOFFR') && user.isOfferValidator()) || user.hasService('EORDR'))">
				<span translate>product.card.new.specification</span>
			</button>
		</div>

		<!-- content -->
		<copo-product-card-content [productFieldsObs]="productFieldsObs"></copo-product-card-content>
	</ng-container>
</div>
